import { complaintmodel } from "../../models/complaints/complaint-model";
import * as XLSX from 'xlsx';
 
export const complaintExport = (complaintList : complaintmodel[]) => {
        const orderData = complaintWiseData(complaintList);
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(orderData);
 
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'ComplaintListExport.xlsx');
}
const complaintWiseData = (complaintList : complaintmodel[]) => {
    var flatData: any = [];
    complaintList?.forEach((complaint) => {  
        flatData.push({
            'Complaint Date': new Date(complaint.complaintDate).toLocaleDateString(),
            'User Name': complaint.custName,
            'Invoice No': complaint.invoiceNo,
            'Product Name': complaint.productName,
            'Category': complaint.productCategory,
           'Complaint Category': complaint.complaintCategory,
            'Packing Type': complaint.packingType,
            'Date Code & Batch Code': complaint.dateCodeBatchCode,
            'Description': complaint.description,
            'Remarks': complaint.remarks,
            'Complaint Type': complaint.complaintType,
            'Corrective Action': complaint.correctiveAction,
            'Preventive Action': complaint.preventiveAction,
            'Customer Support Action': complaint.customerSupportAction,
            'Created By': complaint.createdby,
            'Action By': complaint.actionedbyname,
            'Status': complaint.status,
            'Action Date': new Date(complaint.actionDate).toLocaleDateString(),
            'Complaint Satisfaction': complaint.complainantSatisfaction,
            'Severity': complaint.severity,
            'COPQ in Rs': complaint.copqInRs
        })        
    });
    return flatData;
}
 